import { PseudoPostType } from 'constants/post';
import { canAcceptAttachmentsFromPseudoType } from './helpers';
import { AttachmentsHandlerFunction } from './types';
import { AttachmentCardMedium, AttachmentCards } from 'types/Attachments';

export const processStoryAttachments =
  ({
    acceptedPseudoTypes = [PseudoPostType.Reel],
  }: {
    acceptedPseudoTypes?: PseudoPostType[];
  }) =>
  ({
    form,
    pseudoPost,
    attachmentsByPseudoType,
  }: AttachmentsHandlerFunction) => {
    const selectedPseudoPost = PseudoPostType.Story;
    let attachmentCards: AttachmentCards<AttachmentCardMedium> = [];

    const canAccept = canAcceptAttachmentsFromPseudoType({
      pseudoTypes: acceptedPseudoTypes,
      pseudoPost: pseudoPost.key,
      attachmentsByPseudoType,
    });

    if (canAccept) {
      if (form.pseudoType === selectedPseudoPost) {
        const hasUploadedPhoto = form.attachments?.cards?.length > 0;

        if (hasUploadedPhoto) {
          attachmentCards = form.attachments?.cards ?? [];

          const firstVideo = attachmentCards.find(
            (card) => card.medium?.type === 'video',
          );

          attachmentCards = firstVideo ? [firstVideo] : [];
        }
      }
      return attachmentCards;
    }

    return attachmentsByPseudoType[pseudoPost.key]?.cards ?? [];
  };
